export const reduxName = 'configuration';